<template>
  <div>
    <a-card style="width: 100%">
      <a-row :gutter="[48, 24]">
        <a-col :span="12">
          <a-form :layout="formLayout" style="margin-top: 5%">
            <a-form-item
              label="Type"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select defaultValue="genename">
                <a-select-option value="genename">
                  Gene Symbol
                </a-select-option>
                <a-select-option value="ensgId"> Ensembl ID </a-select-option>
                <a-select-option value="ncbi"> Entrez ID </a-select-option>
                <a-select-option value="alias"> Alias </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              label="Species"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-select defaultValue="Human">
                <a-select-option value="Human"> Human </a-select-option>
                <a-select-option value="Mouse"> Mouse </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <span slot="label">
                <span style="color: red">*</span> Log2FC
                <a-tooltip
                  title="Based on the characteristics of scRNA-seq, we recommend that the absolute value of this parameter is not less than 0.2 (default 0.25)."
                >
                  <a-icon type="question-circle" />
                </a-tooltip>
              </span>
              <a-input-number
                :min="0"
                :max="10"
                :step="0.1"
                placeholder="0.25"
                style="width: 100%"
                v-model="log2fc"
              />
            </a-form-item>
            <a-form-item
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <span slot="label"> <span style="color: red">*</span> Input</span>
              <a-input placeholder="CUL3" v-model="perturbedgene" />
            </a-form-item>
            <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
              <a-button type="primary" @click="submit"> Submit </a-button>
            </a-form-item>
          </a-form>
        </a-col>
        <a-col :span="12"
          ><div id="degene" :style="{ width: '100%', height: '350px' }"></div
        ></a-col>
      </a-row>
    </a-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formLayout: "horizontal",
      perturbedgene: "",
      log2fc: 0.25,
      xaxis: ["Human", "Mouse"],
      yaxis: [15000, 3000],
    };
  },
  mounted() {
    this.drawdegenecount(this.xaxis, this.yaxis);
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 },
          }
        : {};
    },
  },
  methods: {
    drawdegenecount(gene, percent) {
      // 基于刚刚准备好的 DOM 容器，初始化 EChart 实例
      let myChart = this.$echarts.init(document.getElementById("degene"));
      // 绘制图表
      myChart.setOption({
        title: { text: "Numbe of gene perturbations per species[For example]" },
        tooltip: {},
        height: 250,
        // width:"100%",
        // height:"290px",
        xAxis: {
          axisLabel: {
            // rotate: -45,
            color: "black",
          },
          data: gene,
        },
        yAxis: {},
        series: [
          {
            name: "No. of genes",
            type: "bar",
            data: percent,
          },
        ],
      });
      //随着窗口的拖动,图自适应窗口的大小
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    submit() {
      if (this.perturbedgene == "") {
        this.$message.warning("Input can not be empty, please check!", 3);
      }
    },
    handleFormLayoutChange(e) {
      this.formLayout = e.target.value;
    },
  },
};
</script>
<style scpoed></style>
